import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  // Preserve the source line breaks in multi-line restriction text and keep it readable.
  text: {
    whiteSpace: 'pre-wrap',
    padding: theme.spacing(1, 0)
  }
}));

export default useStyles;
